import {DeleteRequestFile} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRequestDeleteFile} from 'data/usecases/private/authorizations/request';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {AuthorizationsFlowEndpoints} from '../../../endpoints';

export const makeDeleteRequestFile = ({
	nuControle,
	nuArquivo,
}: {
	nuControle: string;
	nuArquivo: string;
}): DeleteRequestFile => {
	const path = AuthorizationsFlowEndpoints.deleteFile
		.replace(':nuControle', nuControle)
		.replace(':nuArquivo', nuArquivo);
	return new RemoteRequestDeleteFile(makeBFFApiUrl(path), makeAuthorizeHttpClientDecorator());
};
